import { inarixColors } from "inarix-theme";
import { CSSProperties } from "react";

export const DateRangePickerStyles = {
  DateButton: {
    background: inarixColors.contrast_inarix,
    borderRadius: "5px",
    width: "191px",
    height: "37px",
    fontSize: 12,
    border: `solid 1px #C0C0C0`,
    color: inarixColors.primary_text_inarix,
    "&:hover": {
      backgroundColor: inarixColors.action_hover_inarix,
      border: `solid 0.5px`,
      boxShadow: "none",
    },
  },

  activeButton: {
    backgroundColor: "#1976d2",
    color: "#ffff",
    border: `solid 0.5px`,
    boxShadow: "none",
    "&:hover": {
      backgroundColor: "#2196f3",
      borderColor: "#1976d2",
    },
  },
  dialogActions: {
    position: "absolute",
    bottom: 0,
    right: 0,
  },
  dialogActionsExpanded: {
    backgroundColor: "white",
    position: "fixed",
    boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.2)",
    bottom: -70,
    width: "100%",
  },
  cancelApplyButton: {
    textTransform: "none",
  },
  presetButton: {
    background: "white",
    fontSize: "0.65rem",
    padding: "4px 8px",
    minWidth: "60px",
    borderColor: "#2196f3",
    color: "#2196f3",
    textTransform: "none",
    "&:hover": {
      backgroundColor: "#e3f2fd",
      borderColor: "#1976d2",
    },
  },
  dateButtonOrange: {
    backgroundColor: "#ff9800 !important",
    color: "white !important",
    "&:hover": {
      backgroundColor: "#f57c00 !important",
    },
  },
  containerDiv: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    gap: "16px",
  } as CSSProperties,
  presetsContainer: {
    display: "flex",
    justifyContent: "center",
    gap: "8px",
    borderBottom: "1px solid #e0e0e0",
    paddingBottom: "16px",
    flexWrap: "wrap",
  } as CSSProperties,
  actionsContainer: {
    display: "flex",
    justifyContent: "flex-end",
    gap: "8px",
  } as CSSProperties,
};
